export const MATERIALS_KEYS = {
  RECORDS: "materials-materials",
  BY_ID: "by-id",
};
